import { useState, useEffect } from "react";
import {
  Loading,
  SecondaryContainer as CommonContainer,
  Pagination,
} from "components";
import { useLocale } from "hooks";
import { ApiService } from "services/serverInClient";
import translation from "./translation";
import { CONTENT_TYPES } from "utils/constants";
import { normalizeHomeResearchCenters } from "utils/normalizer";
import { GetContentParams } from "types";
import { Formatter } from "utils";
import { toast } from "react-toastify";
import PersonCard from "./components/PersonCard";

const ITEMS_PER_PAGE = 8;
const apiService = new ApiService("fa");

function TabGraduatedsRenderer({ tagTree }) {
  const { locale } = useLocale();
  const [listData, setListData] = useState<Array<any>>([]);
  const [totalPagesCount, setTotalPagesCount] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = async (inputParams = { page: 1 }) => {
    const page = inputParams?.page || 1;
    delete inputParams.page;
    let params: GetContentParams = {
      tagTrees: [tagTree],
      size: ITEMS_PER_PAGE,
      offset: (page - 1) * ITEMS_PER_PAGE,
      contentTypeUniqueId: CONTENT_TYPES.RESEARCH_CARD,
      orderBy: ["content.ResearchPriority:asc"],
      ...inputParams,
    };
    try {
      setLoading(true);
      const apiService = new ApiService("fa");
      const response = await apiService.getContent(params, {
        formatter: false,
      });
      setTotalPagesCount(Math.ceil((response?.count || 0) / ITEMS_PER_PAGE));
      const unsortedList = Formatter.formatData({ data: response });
      setListData(normalizeHomeResearchCenters(unsortedList) || []);
    } catch (error) {
      toast.error("خطایی رخ داد");
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [tagTree]);

  function handlePageClick(d) {
    const selected = d?.selected + 1;
    setCurrentPage(selected);
    fetchData({ page: selected });
  }

  const renderList = () => {
    if (listData.length % 2 === 0)
      return (
        <div className="tw-grid tw-gap-5 lg:tw-grid-cols-2">
          {listData?.map((item) => (
            <PersonCard {...item} />
          ))}
        </div>
      );

    return (
      <>
        <div className="tw-grid tw-gap-5 lg:tw-grid-cols-2">
          {listData.slice(0, -1)?.map((item) => (
            <PersonCard {...item} />
          ))}
        </div>
        <div className="tw-flex tw-w-full lg:tw-w-1/2 tw-mx-auto tw-justify-center tw-mt-5">
          <PersonCard {...listData.at(-1)} />
        </div>
      </>
    );
  };

  return (
    <>
      <CommonContainer className="tw-px-4 md:tw-px-0 tw-pb-8">
        <div>
          {loading ? (
            <div className="tw-min-h-[200px] tw-flex tw-items-center tw-justify-center loading">
              <Loading />
            </div>
          ) : (
            <div className="tw-mt-[30px]">
              {listData?.length === 0 ? (
                <div className="tw-text-center">
                  {translation[locale]?.NOT_FOUND}
                </div>
              ) : (
                renderList()
              )}
              <div className="tw-mt-5">
                {Boolean(totalPagesCount) && (
                  <Pagination
                    currentPage={currentPage}
                    handlePageClick={handlePageClick}
                    totalPagesCount={totalPagesCount}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </CommonContainer>
    </>
  );
}

export default TabGraduatedsRenderer;
